if ( typeof google === 'object' && typeof google.maps === 'object' ) {
  var iconAnchor = new google.maps.Point(55, 55);
  var iconSize = new google.maps.Size(40, 40);

  var mapIcon = {
  	url: '/assets/images/map-pin.svg',
  	anchor: iconAnchor,
  	scaledSize: iconSize,
  	size: iconSize,
  	optimize: false
  };

  var mapOptions = {
  	disableDefaultUI: true,
  	zoomControl: true,
  	streetViewControl: true,
  	signInControl: false,
  	scrollwheel: true,
  	scaleControl: true,
  	rotateControl: true,
  	panControl: true,
  	mapTypeControl: true,
  	fullscreenControl: true,
  	zoom: 18,
  	// mapTypeId: google.maps.MapTypeId.ROADMAP,
    // mapTypeId: 'satellite', // can be roadmap (default), satellite, hybrid, or terrain
    // tilt: 45,
  };

  var mapStyles = [
    {
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#f49f53"
            }
        ]
    },
    {
        "featureType": "landscape",
        "stylers": [
            {
                "color": "#f9ddc5"
            },
            {
                "lightness": -7
            }
        ]
    },
    {
        "featureType": "road",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 43
            }
        ]
    },
    {
        "featureType": "poi.business",
        "stylers": [
            {
                "color": "#645c20"
            },
            {
                "lightness": 38
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "color": "#1994bf"
            },
            {
                "saturation": -69
            },
            {
                "gamma": 0.99
            },
            {
                "lightness": 43
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#f19f53"
            },
            {
                "weight": 1.3
            },
            {
                "visibility": "on"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi.business"
    },
    {
        "featureType": "poi.park",
        "stylers": [
            {
                "color": "#645c20"
            },
            {
                "lightness": 39
            }
        ]
    },
    {
        "featureType": "poi.school",
        "stylers": [
            {
                "color": "#a95521"
            },
            {
                "lightness": 35
            }
        ]
    },
    {},
    {
        "featureType": "poi.medical",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 38
            },
            {
                "visibility": "off"
            }
        ]
    },
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {
        "elementType": "labels"
    },
    {
        "featureType": "poi.sports_complex",
        "stylers": [
            {
                "color": "#9e5916"
            },
            {
                "lightness": 32
            }
        ]
    },
    {},
    {
        "featureType": "poi.government",
        "stylers": [
            {
                "color": "#9e5916"
            },
            {
                "lightness": 46
            }
        ]
    },
    {
        "featureType": "transit.station",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 22
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "lightness": 38
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#f19f53"
            },
            {
                "lightness": -10
            }
        ]
    },
    {},
    {},
    {}
  ];
}

const googleMaps = {
	init (_) {
		/*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type function
    *  @date 8/11/2013
    *  @since  4.3.0
    *
    *  @param  $el (jQuery element)
    *  @return n/a
    */

		function new_map ($el) {
      // String
      var type = $el.attr('data-type') !== undefined ? $el.attr('data-type') : 'roadmap';

      // Int
      var tilt = $el.attr('data-tilt') !== undefined ? parseInt($el.attr('data-tilt')) : 0;

      // Int
      var zoom = $el.attr('data-zoom') !== undefined ? parseInt($el.attr('data-zoom')) : 18;

      // Int
      var minZoom = $el.attr('data-minZoom') !== undefined ? parseInt($el.attr('data-minZoom')) : 0;

      // Int
      var maxZoom = $el.attr('data-maxZoom') !== undefined ? parseInt($el.attr('data-maxZoom')) : 22;

      // Boolean
      var connectedMarkers = $el.attr('data-connected-markers') !== undefined && $el.attr('data-connected-markers') == 'true' ? true : false;

      // Boolean
      var connectedMarkersSeparate = $el.attr('data-separate-marker-groups') !== undefined && $el.attr('data-separate-marker-groups') == 'true' ? true : false;

      // Boolean
      var connectedMarkersClosed = $el.attr('data-connected-markers-closed') !== undefined && $el.attr('data-connected-markers-closed') == 'true' ? true : false;

      // Boolean
      var snazzyEnabled = $el.attr('data-snazzy') !== undefined && $el.attr('data-snazzy') == 'true' ? true : false;

      // Grab Markers
      if(connectedMarkers == true || connectedMarkers == 'true') {
        // declare markers
  			var $markers = $el.find('.marker[data-marker-group]');
      } else {
        // declare markers
  			var $markers = $el.find('.marker');
      }

			// Declare map arguments
			var args = {
				center: new google.maps.LatLng(53.585927, -8.142682),
				options: mapOptions,
        mapTypeId: type ? type : 'roadmap', // can be roadmap (default), satellite, hybrid, or terrain
        tilt: tilt ? tilt : 0,
        zoom: zoom ? zoom : 18,
        minZoom: minZoom ? minZoom : 0,
        maxZoom: maxZoom ? maxZoom : 22,
        styles: snazzyEnabled ? mapStyles : [],
			};

			// create new map
			var map = new google.maps.Map($el[0], args);

			// add a markers reference
			map.markers = [];

			// add markers
      if(connectedMarkers == true || connectedMarkers == 'true') {
        console.log( 'loop through markers' );

        // console.log(type);
        // console.log(tilt);
        // console.log(zoom);
        // console.log(minZoom);
        // console.log(maxZoom);
        // console.log(snazzyEnabled);
        // console.log(connectedMarkers);

        var markerGroups = [];

        if (connectedMarkersSeparate == true || connectedMarkersSeparate == 'true') {
          let groupedMarkers = _.groupBy($markers, markerItem => jQuery(markerItem).attr('data-marker-group'));

          console.log(groupedMarkers);

          // groupedMarkers.values().forEach(function (k, v) {
          //   console.log("Jimmy Test");
          //   console.log(k);
          //   console.log(v);
          // });

          for (var [key, value] of Object.entries(groupedMarkers)) {
            console.log(`jQuery{key}: jQuery{value}`);

            for (let i = 0; i < value.length; i++) {
              console.log(i);
              console.log(value[i]);

              // mappedMarker returns the index of the added marker
              let mappedMarker = add_marker(jQuery(value[i]), map, i, jQuery(value).attr('data-group-colour'));

              if (i == 0) {
                var firstMappedMarker = mappedMarker;
              }

              if (i > 0) {
                console.log(map.markers);
                console.log(mappedMarker);
                var polyline = new google.maps.Polyline({
                  path: [map.markers[mappedMarker - 1].getPosition(), map.markers[mappedMarker].getPosition()],
                  strokeColor: jQuery(value).attr('data-group-colour') !== undefined ? '#' + jQuery(value).attr('data-group-colour') : '#FF0000',
                  strokeOpacity: 1.0,
                  strokeWeight: 2,
                  map: map
                });

                if ( i === (value.length - 1) ) {
                  if (connectedMarkersClosed == true || connectedMarkersClosed == 'true') {
                    var polyline = new google.maps.Polyline({
                      path: [map.markers[mappedMarker].getPosition(), map.markers[firstMappedMarker].getPosition()],
                      strokeColor: jQuery(value).attr('data-group-colour') !== undefined ? '#' + jQuery(value).attr('data-group-colour') : '#FF0000',
                      strokeOpacity: 1.0,
                      strokeWeight: 2,
                      map: map
                    });
                  }
                }
              }
            }
          }

        } else {
          $markers.each(function (k, v) {
            console.log(k);
            console.log(v);
    				add_marker(jQuery(this), map, k, jQuery(v).attr('data-group-colour'));

            // let markerGroup = jQuery(v).attr('data-marker-group');

            if (k > 0) {
              var polyline = new google.maps.Polyline({
                path: [map.markers[k - 1].getPosition(), map.markers[k].getPosition()],
                strokeColor: jQuery(v).attr('data-group-colour') !== undefined ? '#' + jQuery(v).attr('data-group-colour') : '#FF0000',
                strokeOpacity: 1.0,
                strokeWeight: 2,
                map: map
              });

              if ( k === ($markers.length - 1) ) {
                if (connectedMarkersClosed == true || connectedMarkersClosed == 'true') {
                  var polyline = new google.maps.Polyline({
                    path: [map.markers[k].getPosition(), map.markers[0].getPosition()],
                    strokeColor: jQuery(v).attr('data-group-colour') !== undefined ? '#' + jQuery(v).attr('data-group-colour') : '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: map
                  });
                }
              }
            }
    			});
        }
      } else {
        $markers.each(function (k, v) {
  				add_marker(jQuery(this), map, k);
  			});
      }

			// center map
			center_map(map);

			// return
			return map;
		}

		var infowindow = new google.maps.InfoWindow();

		/*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type function
    *  @date 8/11/2013
    *  @since  4.3.0
    *
    *  @param  $marker (jQuery element)
    *  @param  map (Google Map object)
    *  @return n/a
    */

		function add_marker ($marker, map, i=0, bgColour='FF0000') {
			// var
			var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
			var markerId = $marker.attr('id');
      var markerGroup = $marker.attr('data-marker-group');

			// create marker
			var marker = new google.maps.Marker({
				position: latlng,
				map: map,
				id: markerId,
        markerGroup: markerGroup ? markerGroup : '',
				// icon: mapIcon,
        // https://stackoverflow.com/questions/2436484/how-can-i-create-numbered-map-markers-in-google-maps-v3
        icon: 'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=' + (i + 1) + '|' + bgColour + '|000000'
			});

			// add to array
			map.markers.push(marker);

			// if marker contains HTML, add it to an infoWindow
			if ($marker.html()) {
				google.maps.event.addListener(marker, 'click', function () {
					infowindow.setContent("<div class='infowindow-style'><div class='infowindow-style-item'>" + $marker.html() + '</div></div>');
					infowindow.open(map, marker);
				});
			}

      return (map.markers.length - 1);
		}

		/*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type function
    *  @date 8/11/2013
    *  @since  4.3.0
    *
    *  @param  map (Google Map object)
    *  @return n/a
    */

		function center_map (map) {
			// vars
			var bounds = new google.maps.LatLngBounds();

			// loop through all markers and create bounds
			jQuery.each(map.markers, function (i, marker) {
				var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

				bounds.extend(latlng);
			});

			// Use map.fitBounds function if you wish to dynamically fit the map to the markers.
			// only 1 marker?
			if( map.markers.length == 1 ) {
			  // set center of map
			  map.setCenter( bounds.getCenter() );
			  map.setZoom( 7 );
			}
			else {
			  // fit to bounds
			  map.fitBounds( bounds );
			}

			// Set to 7 for testing, decent level for Ireland
			map.setZoom(9);
		}

		var map = null;

		// Create Gmap Map for each map div
		jQuery('.o-map').each(function () {
			// create map
			map = new_map(jQuery(this));
		});
	}
};

export default googleMaps;
